module.exports = __webpack_public_path__ + "img/stages_of_scaling.8be8b536.png";